(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventScheduleDialogController', EventScheduleDialogController);

    EventScheduleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EventSchedule', 'Employee'];

    function EventScheduleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EventSchedule, Employee) {
        var vm = this;
        vm.eventSchedule = entity;
        vm.employees = Employee.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:eventScheduleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.eventSchedule.id !== null) {
                EventSchedule.update(vm.eventSchedule, onSaveSuccess, onSaveError);
            } else {
                EventSchedule.save(vm.eventSchedule, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startedAt = false;
        vm.datePickerOpenStatus.finishedAt = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
